import type { Bid } from '@/data'
import api from '..'
import type { BidRungConditionPayload } from './createBidRung'

export interface BidRungSyncItem {
  id: number
  name: string
  bid_amount: number
  priority: number
  active: boolean
  conditions: BidRungConditionPayload[]
}

export interface SyncBidRungsPayload {
  partner_id: number
  rungs: BidRungSyncItem[]
}

export async function syncBidRungs(
  payload: SyncBidRungsPayload,
): Promise<Bid[]> {
  const res = await api.post('/bid-rungs/sync', payload)
  return res.data.data
}
